import { saga } from './saga';

export default { key: 'split', saga: saga };
